import { render } from "./Netz.vue?vue&type=template&id=72e5a5a0&scoped=true"
import script from "./Netz.vue?vue&type=script&lang=js"
export * from "./Netz.vue?vue&type=script&lang=js"

import "./Netz.vue?vue&type=style&index=0&id=72e5a5a0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/metal-client/metal-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72e5a5a0"]])

export default __exports__